let language = {
    "LBL_HOME":"Home",
    "LBL_ADD_BUDGETHEAD": "Create Reviewer Documents",
    "LBL_VIEW_BUDGETHEAD": "View Reviewer Documents",
    "LBL_FILE_NAME": "File Name",
    "LBL_BRANCH": "Branch",
    "LBL_EMAIL": "Email",
    "LBL_PHONE":"Phone",
    "LBL_GENDER":"Gender",
    "LBL_IMAGE":"Image",
    "LBL_DOB":"DOB",
    "LBL_STATUS":"Status",
    "LBL_HOBBIES":"Hobbies",
    "LBL_SINGING":"Singing",
    "LBL_DANCE":"Dancing",
    "LBL_CREATE_DATE":"Date Created",
    "LBL_ENTERED":"Date Entered",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_DOWNLOAD_FILE":"Download",
   // "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_EDIT":"Edit",
    "LBL_DELETE":"Delete",
    "LBL_ADDED_BY":"Created By",
    "LBL_OPPORTUNITY_NO":"Opportunity No.",
    "LBL_OPP_FUNDER":"Funder",
    "LBL_OPP_OWNER":"Opportunity Owner",
    "LBL_OPP_DEADLINE":"Application Deadline",
    "LBL_LISTING":"Listing",
    "LBL_SNO":"S.No.",
    "LBL_ITEM":"Item",
    "LBL_UPLOAD_DATE":"Upload Date",
    "LBL_ACTION":"Action",
    "LBL_UPLOAD":"Upload",
    "LBL_UPLOAD_FILE":"Upload File",
    "LBL_APPLICATION_DOCUMENT":"Application Document",
    "LBL_REVIEWER_DOCUMENT":"Reviewer Document",
    "LBL_SERIAL_NO":"S.No.",
    "LBL_ITEM_NAME":"Item Name",
    "LBL_APPLICATION_TITLE":"Application Title",
    "LBL_OPPORTUNITY_TITLE":"Opportunity Title",
    "LBL_UPLOAD_BY":"Upload By",
    "LBL_NOTIFY":"Notify",
    "LBL_ACCEPT":"Accept",
    "LBL_REJECT":"Reject",
    
}

export default language;